<template>
  <div class="header">
    <div class="inner">
          <div class="logo-wrapper l"><img class="logo" :src="logoUrl" /></div>
      <ul class="nav-list tr">
        <router-link
           tag="li"
           class="item dib"
           :class="pageName === nav.path ? 'is-active' :''"
           v-for="nav in navList"
           :to="nav.path"
           :key="nav.path"
            rel="noopener">
          {{nav.name}}
        </router-link>
      </ul>
      <div class="login-btn dn">登陆</div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'pageHeader',
  data () {
    return {
      // pageName: '',
      navList: [
        {
          path: 'home',
          name: '首页'
        },
        {
          path: 'product',
          name: '产品介绍'
        },
        {
          path: 'cooperation',
          name: '合作案例'
        },
        {
          path: 'about',
          name: '关于我们'
        }
      ],
      logoUrl: 'https://cookhere-images.oss-cn-shenzhen.aliyuncs.com/202105/logo.png'
    }
  },
  computed: {
    pageName ({ $route: { name } }) {
      return name
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  height: 120px;
  background-color: #000;
  .inner {
    width: 100vw;
    margin: 0 auto;
  }
  &.home {
    height: 120px;
    background-color: #000;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .logo-wrapper {
    padding-top: 50px;
    padding-left: 80px;
    .logo {
      width: 160px;
      height: 40px;
    }
  }
  .nav-list {
    padding-top: 58px;
    // margin-right: 85;
    .item {
      display: inline-block;
      line-height: 32px;
      margin-right: 80px;
      padding-bottom: 20px;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.7);
      cursor: pointer;
      &.is-active {
        color: #cf4d4d;
        //border-bottom: 2px solid;
    }
  }
  }
  .login-btn {
    width: 120px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    background: #cf4d4d;
    border-radius: 25px;
    margin-right: 200px;
  }
}
</style>
